module.exports = __webpack_public_path__ + "static/img/_7.03e2464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_7.png
// module id = 4VrU
// module chunks = 1